import React, { useState } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { Checkbox, ListItemText, Popover, IconButton, Button, Typography, Divider, Fade, Tooltip } from "@material-ui/core";
import MenuOpenSharpIcon from "@material-ui/icons/MenuOpenSharp";
import { makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";


const useStyles = makeStyles((theme) => ({
  iconButton: {
    padding: 0,
    margin: 0,
    minWidth: "auto",
    background: "none",
    border: "none",
    boxShadow: "none",
    transition: "color 0.3s ease-in-out",
    "&:hover": {
      color: theme.palette.primary.main,
    },
  },
  icon: {
    fontSize: "2rem",
    color: theme.mode === "light" ? "#333" : grey[200],
    transition: "color 0.3s ease-in-out",
  },
  button: {
    padding: "6px 16px",
    fontSize: "12px",
    borderRadius: "20px",
    transition: "background-color 0.3s ease-in-out, opacity 0.3s ease-in-out",
  },
  clearButton: {
    backgroundColor: "#f44336",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#d32f2f",
    },
  },
  selectAllButton: {
    backgroundColor: "#4CAF50",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#388E3C",
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    marginTop: "12px",
    marginBottom: "16px",
  },
}));

const TicketsQueueSelect = ({ userQueues, selectedQueueIds = [], onChange }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (queueId) => {
    const newSelectedQueues = selectedQueueIds.includes(queueId)
      ? selectedQueueIds.filter((id) => id !== queueId)
      : [...selectedQueueIds, queueId];

    onChange(newSelectedQueues);
  };

  const handleClearSelection = () => {
    onChange([]); // Limpa a seleção
  };

  const handleSelectAll = () => {
    if (userQueues?.length > 0) {
      onChange(userQueues.map((queue) => queue.id));
    }
  };

  return (
    <div>
      {/* Ícone do menu */}
      <Tooltip title="Filtrar conversas por fila/departamento" placement="top">
        <IconButton onClick={handleClick} className={classes.iconButton}>
          <MenuOpenSharpIcon className={classes.icon} />
        </IconButton>
      </Tooltip>

      {/* Popover para exibir as filas */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          style: { borderRadius: "12px" },
        }}
      >
        <FormControl fullWidth margin="dense">
          {/* Título da Lista */}
          <Typography style={{ fontWeight: "bold", fontSize: "12px", padding: "12px", textAlign: "center" }}>
            Selecione os setores que deseja exibir
          </Typography>

          <Divider style={{ width: "85%" }} />

          {/* Lista de filas com checkboxes */}
          <div style={{ width: "100%" }}>
            {userQueues?.length > 0 &&
              userQueues.map((queue) => (
                <MenuItem
                  dense
                  key={queue.id}
                  onClick={() => handleChange(queue.id)}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Checkbox
                    style={{ color: queue.color, padding: "4px" }}
                    size="small"
                    checked={selectedQueueIds.includes(queue.id)}
                  />
                  <ListItemText primary={queue.name} />
                </MenuItem>
              ))}
          </div>

          {/* Botões de Limpar e Selecionar Tudo com Fade-in/Fade-out independente */}
          {userQueues.length > 0 && (
            <div className={classes.buttonContainer}>
              <Fade in={selectedQueueIds.length > 0} timeout={300}>
                <div>
                  {selectedQueueIds.length > 0 && (
                    <Button
                      className={`${classes.button} ${classes.clearButton}`}
                      onClick={handleClearSelection}
                      variant="contained"
                    >
                      Limpar
                    </Button>
                  )}
                </div>
              </Fade>

              <Fade in={selectedQueueIds.length !== userQueues.length} timeout={300}>
                <div>
                  {selectedQueueIds.length !== userQueues.length && (
                    <Button
                      className={`${classes.button} ${classes.selectAllButton}`}
                      onClick={handleSelectAll}
                      variant="contained"
                    >
                      Selecionar Tudo
                    </Button>
                  )}
                </div>
              </Fade>
            </div>
          )}
        </FormControl>
      </Popover>
    </div>
  );
};

export default TicketsQueueSelect;
